// extracted by mini-css-extract-plugin
export default {"root":"root__3eR0K","overlay":"overlay__3lrOn","overlay_active":"overlay_active__1H3hI","overlay__text":"overlay__text__3dvAh"};